import { MoosaDataService } from '@discngine/moosa-data';

export const dataService = new MoosaDataService('api');
